var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-date"},[(_vm.date)?_c('div',[_vm._v(" "+_vm._s(_vm.$moment(_vm.date).format("DD.MM.YYYY")))]):_vm._e(),(_vm.date)?_c('div',[_vm._v(" "+_vm._s(_vm.$moment(_vm.date).format("HH:mm")))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }